import instance from './instance';
import {TLocationType, TLocationsTree} from './types';

export const fetchLocationsList = () =>
  instance.get<TLocationsTree>('/frontend/api/v1/promo/locations');

export interface TSuggestionCity {
  id: number;
  type: TLocationType.City;
  name: string;
  items: any[];
  county: {
    type: TLocationType.County;
    id: number;
    name: string;
  } | null;
  state?: {
    type: TLocationType.State;
    id: number;
    name: string;
  } | null;
  country: {
    id: number;
    type: TLocationType.Country;
    name: string;
  };
}

type TCitySuggestionsResponse = {
  results: TSuggestionCity[];
};

export const fetchCitySuggestions = (query: string, controller: any) =>
  instance.get<TCitySuggestionsResponse>(`/frontend/api/v1/promo/city/suggestions?query=${query}`, {
    signal: controller.signal,
  });
